import React from 'react';

import { InputAdornment as InputAdornmentMaterial, InputAdornmentProps } from '@mui/material';

type Props = InputAdornmentProps;

export const InputAdornment = (props: Props) => <InputAdornmentMaterial {...props} />;
